import styled from 'styled-components'
import {translate} from 'react-i18next'
import React from 'react'

import Note from 'components/Note'
import Link from 'components/Link'

const LinkWrapper = styled.div`
  margin-top: 20px;
`

const ResetPasswordLinkTitle = styled(Note)`
  margin: 20px 0 10px 0;
`
const ResetPasswordLink = ({t, onClick}) => (
  <LinkWrapper>
    <ResetPasswordLinkTitle>{t('email.resend-question')}</ResetPasswordLinkTitle>
    <Link onClick={onClick} external secondary>
      {t('email.resend')}
    </Link>
  </LinkWrapper>
)

export default translate()(ResetPasswordLink)
